import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Layout from './pages/Layouts';
import ExceptionHandler from './ExceptionHandler';

import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/style.module.css";

const NoMatch = lazy(() => import('./components/Materials/NoMatch'));
const Home = lazy(() => import('./pages/Home'));

const SuspendPage = (element, fallback = <div />) => {
    return (
        <Suspense fallback={fallback}>
            {element}
        </Suspense>
    )
}

export default function App() {
    return (
        <BrowserRouter>
            <ExceptionHandler>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path='/' index element={SuspendPage(<Home />)} />
                        <Route path="*" element={SuspendPage(<NoMatch />)} />
                    </Route>
                </Routes>
                <ToastContainer />
            </ExceptionHandler>
        </BrowserRouter>
    )
}